// Prevent redeclaration if script is loaded multiple times
if (typeof window.ProductCalculatorClass === 'undefined') {
  window.ProductCalculatorClass = class ProductCalculator {
    constructor() {
      this.resetFields();
      this.bindEvents();
    }

  resetFields() {
    // Reset main product fields
    document.querySelectorAll('[id*=area_needed]').forEach(el => el.value = "");
    document.querySelectorAll('.product_price_overage_new').forEach(el => el.textContent = "");
    document.querySelectorAll('.qty').forEach(el => el.value = 1);
    const sampleQty = document.querySelector('[id*=sample_quantity]');
    if (sampleQty) sampleQty.value = 1;
    
    // Reset calculator fields
    document.querySelectorAll('#ft_need').forEach(el => el.value = "");
    document.querySelectorAll('#finalquantity').forEach(el => el.value = 1);
  }

  bindEvents() {
    // Overage checkbox change handler
    document.addEventListener('change', (e) => {
      if (e.target.matches('#overage_checkbox')) {
        this.handleOverageCheckbox(e.target.checked);
      }
      if (e.target.matches('input[name="overage_percent"]')) {
        this.handleOveragePercentChange();
      }
    });

    // Main product area needed input
    document.addEventListener('change', (e) => {
      if (e.target.matches('#ft_need')) {
        this.handleAreaNeeded(e.target.value);
      }
      if (e.target.matches('#finalquantity')) {
        // Check if this change was triggered by user input (not programmatic)
        if (e.target === document.activeElement) {
          this.handleManualFinalQuantityChange(e.target.value);
        } else {
          this.handleFinalQuantity(e.target.value);
        }
      }
    });
    document.addEventListener('keyup', (e) => {
      if (e.target.matches('#ft_need')) {
        this.handleAreaNeeded(e.target.value);
      }
      if (e.target.matches('#finalquantity')) {
        // Check if this change was triggered by user input (not programmatic)
        if (e.target === document.activeElement) {
          this.handleManualFinalQuantityChange(e.target.value);
        } else {
          this.handleFinalQuantity(e.target.value);
        }
      }
    });
    // Modal area needed input
    document.addEventListener('change', (e) => {
      if (e.target.closest('.modal__inner [id*=ft_need-modal]')) {
        this.handleModalAreaNeeded(e);
      }
    });
    document.addEventListener('keyup', (e) => {
      if (e.target.closest('.modal__inner [id*=ft_need-modal]')) {
        this.handleModalAreaNeeded(e);
      }
    });
    
    // Listen for variant changes
    document.addEventListener('variant:change', () => {
      this.handleVariantChange();
    });
    
    // Also listen for custom variant change events
    document.addEventListener('variant:updated', () => {
      this.handleVariantChange();
    });
    
    // Listen for Alpine.js variant changes
    document.addEventListener('alpine:init', () => {
      if (window.Alpine) {
        window.Alpine.store('xVariantSelect', {
          ...window.Alpine.store('xVariantSelect'),
          onVariantChange: () => {
            this.handleVariantChange();
          }
        });
      }
    });
    
    // Listen for custom variant change events from the theme
    document.addEventListener('eurus:product-page-variant-select:updated', () => {
      this.handleVariantChange();
    });
    
    document.addEventListener('eurus:product-card-variant-select:updated', () => {
      this.handleVariantChange();
    });
    
    // Listen for quantity picker changes
    document.addEventListener('change', (e) => {
      if (e.target.matches('input[name="quantity"]') && e.target.closest('.quantity-selector-container')) {
        this.handleQuantityPickerChange(e.target.value);
      }
    });
    
    // Also listen for direct Alpine.js qty changes (plus/minus buttons)
    document.addEventListener('click', (e) => {
      if (e.target.closest('button[name="plus"], button[name="minus"]') && 
          e.target.closest('.quantity-selector-container')) {
        // Small delay to allow Alpine.js to update first
        setTimeout(() => {
          const qtyInput = e.target.closest('.quantity-selector-container').querySelector('input[name="quantity"]');
          if (qtyInput) {
            this.handleQuantityPickerChange(qtyInput.value);
          }
        }, 10);
      }
    });
  }

  handleFinalQuantity(val) {
    if (!val) return;
    const v_id = this.getInputValueByName('id');
    const variant = window.meta?.product?.variants?.find(item => String(item.id) === String(v_id));
    
    // Update finalquantity inputs
    document.querySelectorAll('#finalquantity').forEach(el => el.value = val);
    
    // Update quantity picker inputs
    document.querySelectorAll('.product__quantity input[name="quantity"]').forEach(el => el.value = val);
    
    // Update Alpine.js quantity picker data
    this.updateAlpineQuantity(val);
    
    if (variant) {
      const price = variant.price;
      const total_price = parseFloat(price * val);
      const tot_price = this.formatMoney(total_price);
      document.querySelectorAll('.total-value').forEach(el => {
        el.innerHTML = tot_price;
      });
    }
  }

  handleAreaNeeded(val) {
    if (!val) return;
    const actual_area_el = document.querySelector('#area_actual');
    if (!actual_area_el) return;
    const actual_area = parseFloat(actual_area_el.innerHTML);
    let base_sq_ft = parseFloat(val);
    let total_sq_ft_needed = base_sq_ft;

    // Check if overage checkbox is checked
    const overageCheckbox = document.querySelector('#overage_checkbox');
    if (overageCheckbox && overageCheckbox.checked) {
      const selectedPercent = document.querySelector('input[name="overage_percent"]:checked');
      const overagePercent = selectedPercent ? parseFloat(selectedPercent.value) : 20;
      total_sq_ft_needed = base_sq_ft * (1 + overagePercent / 100);
    }

    total_sq_ft_needed = Number(total_sq_ft_needed.toFixed(2));
    const SQ_FT_per_box = Number(actual_area.toFixed(2));
    let tot_num_boxes = Number((total_sq_ft_needed / SQ_FT_per_box).toFixed(2));
    if (tot_num_boxes) {
      // Update finalquantity input
      tot_num_boxes = Math.ceil(tot_num_boxes);
      document.querySelectorAll('#finalquantity').forEach(el => el.value = tot_num_boxes);
      document.querySelectorAll('.product__quantity input[name="quantity"]').forEach(el => el.value = tot_num_boxes);

      // Update Alpine.js quantity picker data
      this.updateAlpineQuantity(tot_num_boxes);
      const v_id = this.getInputValueByName('id');
      const variant = window.meta?.product?.variants?.find(item => String(item.id) === String(v_id));
      if (variant) {
        const price = variant.price;
        const total_price = parseFloat(price * tot_num_boxes);
        const tot_price = this.formatMoney(total_price);
        document.querySelectorAll('.total-value').forEach(el => {
          el.innerHTML = tot_price;
        });

        // Update Sqft Price display
        if (actual_area > 0) {
          const sqft_price = price / actual_area;
          const formatted_sqft_price = this.formatMoney(sqft_price);
          document.querySelectorAll('.calculator-value').forEach(el => {
            if (el.previousElementSibling && el.previousElementSibling.textContent.trim() === 'Sqft Price') {
              el.innerHTML = formatted_sqft_price;
            }
          });


        }
      }
    }
  }

  handleModalAreaNeeded(e) {
    e.preventDefault();
    const input = e.target;
    const _parent = input.closest('.modal__centered-content');
    if (!_parent) return;
    const currentValue = input.value;
    if (!currentValue) return;
    const actual_area = parseFloat(_parent.querySelector('[id*=area_actual-modal]')?.textContent || 0);
    const overage_sq_ft = parseFloat(currentValue);
    const total_sq_ft_needed = Number(overage_sq_ft.toFixed(2));
    const SQ_FT_per_box = Number(actual_area.toFixed(2));
    let tot_num_boxes = Number((total_sq_ft_needed / SQ_FT_per_box).toFixed(2));
    if (tot_num_boxes) {
      _parent.querySelectorAll('[id*=pp_overage_new_1-modal]').forEach(el => el.textContent = tot_num_boxes);
      tot_num_boxes = Math.ceil(tot_num_boxes);
      _parent.querySelectorAll('[id*=finalquantity-modal]').forEach(el => el.value = tot_num_boxes);
      _parent.querySelectorAll('.js-qty__wrapper input[name="quantity"]').forEach(el => el.value = tot_num_boxes);
      const v_id = _parent.querySelector('[name="name"]')?.value;
      const pId = _parent.querySelector('.product-section')?.getAttribute('data-product-id');
      if (!pId) return;
      const jsonEl = _parent.querySelector(`#wcp_json_${pId}-modal`);
      if (!jsonEl) return;
      let productDetails;
      try {
        productDetails = JSON.parse(jsonEl.textContent);
      } catch {
        return;
      }
      const variant = productDetails.variants.find(item => String(item.id) === String(v_id));
      if (variant) {
        const price = variant.price;
        const total_price = parseFloat(price * tot_num_boxes);
        const tot_price = this.formatMoney(total_price);
        _parent.querySelectorAll('[id*=total_price_2-modal]').forEach(el => {
          el.innerHTML = `<span class="amount">${tot_price}</span>`;
        });
      }
    }
  }

  handleVariantChange() {
    // Wait a bit for the DOM to update
    setTimeout(() => {
      this.updateAllPrices();
      // Reset calculator fields when variant changes
      this.resetFields();
    }, 100);
  }

  updateAllPrices() {
    const calculatorWrapper = document.querySelector('.calculator-wrapper');
    if (!calculatorWrapper) return;
    
    const areaActual = parseFloat(calculatorWrapper.getAttribute('data-area-actual') || 0);
    const currentVariant = this.getCurrentVariant();
    
    if (currentVariant && areaActual > 0) {
      const price = currentVariant.price;
      const compareAtPrice = currentVariant.compare_at_price ? parseFloat(currentVariant.compare_at_price) : null;
      const hasComparePrice = compareAtPrice && compareAtPrice > price;
      
      // Update Sqft Price
      const sqftPrice = price / areaActual;
      const formattedSqftPrice = this.formatMoney(sqftPrice);
      document.querySelectorAll('.calculator-value').forEach(el => {
        if (el.previousElementSibling && el.previousElementSibling.textContent.trim() === 'Sqft Price') {
          el.innerHTML = formattedSqftPrice;
        }
      });
      
      // Update Price per Box and compare price
      const formattedBoxPrice = this.formatMoney(price);
      document.querySelectorAll('.price_per_box').forEach(priceBox => {
        priceBox.innerHTML = formattedBoxPrice;
        
        // Update styling based on compare price
        if (hasComparePrice) {
          priceBox.style.color = '#dc3545';
        } else {
          priceBox.style.color = '';
        }
        
        // Find the parent calculator-value div
        const parentDiv = priceBox.closest('.calculator-value');
        if (parentDiv) {
          // Find or create compare price element
          let comparePriceEl = parentDiv.querySelector('[data-compare-price-2]');
          
          if (hasComparePrice) {
            const formattedComparePrice = this.formatMoney(compareAtPrice);
            if (!comparePriceEl) {
              // Create compare price element if it doesn't exist
              comparePriceEl = document.createElement('strike');
              comparePriceEl.setAttribute('data-compare-price-2', '');
              comparePriceEl.className = 'product__price--compare pr-1';
              comparePriceEl.style.color = 'gray';
              parentDiv.insertBefore(comparePriceEl, priceBox);
            }
            comparePriceEl.textContent = formattedComparePrice;
            comparePriceEl.style.display = '';
          } else if (comparePriceEl) {
            // Hide compare price if it exists but shouldn't be shown
            comparePriceEl.style.display = 'none';
          }
        }
      });
      
      // Update Total Price if there's a current quantity
      const currentQuantity = document.querySelector('#finalquantity')?.value || 1;
      if (currentQuantity > 0) {
        const totalPrice = price * currentQuantity;
        const formattedTotalPrice = this.formatMoney(totalPrice);
        document.querySelectorAll('.total-value').forEach(el => {
          el.innerHTML = formattedTotalPrice;
        });
      }
      

    }
  }

  getCurrentVariant() {
    const v_id = this.getInputValueByName('id');
    if (!v_id) return null;
    
    // Try to get variant from window.meta first
    if (window.meta?.product?.variants) {
      const variant = window.meta.product.variants.find(item => String(item.id) === String(v_id));
      if (variant) return variant;
    }
    
    // Fallback: try to get from product JSON
    const productJson = document.querySelector('#ProductJson-product-template');
    if (productJson) {
      try {
        const productData = JSON.parse(productJson.textContent);
        const variant = productData.variants.find(item => String(item.id) === String(v_id));
        if (variant) return variant;
      } catch (e) {
        // Silent error handling for production
      }
    }
    
    return null;
  }

  getInputValueByName(name) {
    const el = document.querySelector(`[name="${name}"]`);
    return el ? el.value : null;
  }

  formatMoney(amount) {
    if (window.theme?.Currency?.formatMoney && window.theme?.settings?.moneyFormat) {
      return window.theme.Currency.formatMoney(amount, window.theme.settings.moneyFormat);
    }
    // fallback
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(amount / 100); // Shopify price is in cents
  }

  // Update Alpine.js quantity picker value
  updateAlpineQuantity(quantity) {
    // Find the quantity selector container and try to update the Alpine.js data
    const qtyContainer = document.querySelector('.quantity-selector-container');
    if (qtyContainer && window.Alpine) {
      // Get the Alpine component data
      const alpineData = window.Alpine.$data(qtyContainer);
      if (alpineData && typeof alpineData.qty !== 'undefined') {
        alpineData.qty = parseInt(quantity);
      }
    }
  }

  // Handle quantity picker changes and sync to calculator
  handleQuantityPickerChange(quantity) {
    if (!quantity || quantity < 1) return;
    
    const intQuantity = parseInt(quantity);
    
    // Update finalquantity inputs without triggering calculator recalculation
    document.querySelectorAll('#finalquantity').forEach(el => {
      if (el.value !== quantity) {
        el.value = intQuantity;
      }
    });
    
    // Update total price based on new quantity
    this.updateTotalPrice(intQuantity);
  }

  // Update total price in calculator
  updateTotalPrice(quantity) {
    const v_id = this.getInputValueByName('id');
    const variant = window.meta?.product?.variants?.find(item => String(item.id) === String(v_id));
    if (variant) {
      const price = variant.price;
      const total_price = parseFloat(price * quantity);
      const tot_price = this.formatMoney(total_price);
      document.querySelectorAll('.total-value').forEach(el => {
        el.innerHTML = tot_price;
      });
    }
  }

  // Handle manual changes to finalquantity input and sync to quantity picker
  handleManualFinalQuantityChange(quantity) {
    if (!quantity || quantity < 1) return;

    const intQuantity = parseInt(quantity);

    // Update all finalquantity inputs
    document.querySelectorAll('#finalquantity').forEach(el => {
      if (el.value != intQuantity) {
        el.value = intQuantity;
      }
    });

    // Update quantity picker inputs
    document.querySelectorAll('.product__quantity input[name="quantity"]').forEach(el => {
      if (el.value != intQuantity) {
        el.value = intQuantity;
      }
    });

    // Update Alpine.js quantity picker data
    this.updateAlpineQuantity(intQuantity);

    // Update total price
    this.updateTotalPrice(intQuantity);
  }

  // Handle overage checkbox toggle
  handleOverageCheckbox(isChecked) {
    const overageMessage = document.querySelector('#overage_message');

    if (isChecked) {
      // Show overage message
      if (overageMessage) {
        overageMessage.style.display = 'flex';
      }
    } else {
      // Hide overage message
      if (overageMessage) {
        overageMessage.style.display = 'none';
      }
    }

    // Recalculate if there's a value in the input
    const ftNeedInput = document.querySelector('#ft_need');
    if (ftNeedInput && ftNeedInput.value) {
      this.handleAreaNeeded(ftNeedInput.value);
    }
  }

  // Handle overage percentage change
  handleOveragePercentChange() {
    const ftNeedInput = document.querySelector('#ft_need');

    // Recalculate if there's a value in the input
    if (ftNeedInput && ftNeedInput.value) {
      this.handleAreaNeeded(ftNeedInput.value);
    }
  }
  };
}

// Initialize calculator when DOM is ready (only if not already initialized)
if (!window.ProductCalculator) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.ProductCalculator = new window.ProductCalculatorClass();
    });
  } else {
    window.ProductCalculator = new window.ProductCalculatorClass();
  }

  // Re-initialize calculator for dynamic content (AJAX)
  document.addEventListener('shopify:section:load', () => {
    window.ProductCalculator = new window.ProductCalculatorClass();
  });
} 